module.exports = __webpack_public_path__ + "e91b34a2465ac1cc7345433816a6c933.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CV.svg
// module id = qhKH
// module chunks = 0